// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.70574 4.07265C7.36549 2.69952 9.60453 2 12 2C14.3955 2 16.6346 2.69952 18.2943 4.07265C19.9732 5.46161 21 7.49484 21 10V11H3.00003V10C3.00003 7.49484 4.02686 5.46161 5.70574 4.07265ZM6.00003 11.7981L9.00003 13.7981L12 11.7981L15 13.7982L18 11.7981L22.3868 14.7226L21.2774 16.3868L18 14.2018L15 16.2019L12 14.2018L9.00003 16.2019L6.00003 14.2019L2.72268 16.3868L1.61328 14.7226L6.00003 11.7981ZM3.00003 17H21V18C21 20.7614 18.7615 23 16 23H8.00003C5.23861 23 3.00003 20.7614 3.00003 18V17Z"}}]};

const HamburgerFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hamburger-filled',
    ref,
    icon: element,
  },
));

HamburgerFilledIcon.displayName = 'HamburgerFilledIcon';

export default HamburgerFilledIcon;
